import { API_URL } from '../../config/api';
import { createMeetingNoteDocument, deleteMeetingNoteDocument } from '../../api/documents';
import { DocumentAttachment } from '../common/DocumentAttachment';

interface MeetingNotesDocumentAttachmentProps {
  projectId: string;
  recordId: string;
  documentUrl?: string | null;
  fileName?: string | null;
  onUpdate?: () => Promise<void>;
  onDocumentChange?: (documentUrl: string | undefined, fileName: string | undefined) => void;
}

export const MeetingNotesDocumentAttachment = ({ projectId, recordId, documentUrl, fileName, onDocumentChange }: MeetingNotesDocumentAttachmentProps) => (
  <DocumentAttachment
    recordLabel="meeting note"
    recordKey={`${projectId}-${recordId}`}
    documentUrl={documentUrl}
    fileName={fileName}
    onDocumentChange={onDocumentChange}
    adapter={{
      upload: async (token, file) => {
        const response = await createMeetingNoteDocument(token, projectId, recordId, file);
        // Prefer the URL the API returns; otherwise build it from the stored file name.
        const name = response.name || file.name;
        const url = response.url || (response as any).document_url
          || `${API_URL}/projects/${projectId}/meeting-notes/${recordId}/document/${encodeURIComponent(name)}`;
        return { ...response, name, url };
      },
      remove: (token) => deleteMeetingNoteDocument(token, projectId, recordId),
    }}
  />
);
